module.exports = __webpack_public_path__ + "img/scanner.5385915a.svg";